<template>
    <div>
        <Formularios></Formularios>
    </div>
</template>


<script>
import Formularios from '../components/Formulario.vue'
export default {
    components:{
        Formularios
    }
}
</script>